import styled, { css } from "styled-components"
import aboutUsBackground from "../../../images/tlo_v1.jpg"
import bochniaBackground from "../../../images/bochnia-header.jpg"

export const SpanBox = styled.div`
  margin-bottom: 75px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 4;
  gap: 13px;

  h1 {
    text-transform: uppercase;
  }

  @media (max-width: 550px) {
    gap: 25px;
  }
`

export const Shadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #030303;
  opacity: 0.6;
  aspect-ratio: 16/9;

  @media (max-width: 1149px) {
    height: 100vh;
    width: 100%;
  }
`

export const Main = styled.div`
  background: url(${aboutUsBackground}) top center no-repeat fixed;
  height: 100vh;
  width: 100%;
  background-size: cover;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 8.5rem;
  width: 100%;
  gap: 13px;
  position: relative;
  aspect-ratio: 16/9;

  @supports (-webkit-touch-callout: none) {
    background: url(${aboutUsBackground}) center top no-repeat scroll;
    background-size: auto 100vh;
  }

  @media (max-width: 1700px) {
    //background-size: auto 100%;
  }

  @media (max-width: 1149px) {
    width: 100%;
    height: 100vh;
    background-position-x: -50px;

    background-size: cover;
  }

  @media (max-width: 799px) {
    width: 100%;
    height: 100vh;
    background-position-x: -160px;

    background-size: cover;
  }

  h1 {
    font-size: 2rem;
    font-weight: 600;
    line-height: 3rem;
    letter-spacing: 0.3em;

    ${props =>
      props.goldHeader === true
        ? css`
            background: linear-gradient(
              97.55deg,
              #ce9638 0%,
              #eae69c 36%,
              #b6872d 90.31%,
              #bb913c 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          `
        : css`
            color: #fdfdfd;
          `}

    z-index: 4;
    margin-top: 25px;

    @media (max-width: 500px) {
      width: 80%;
      text-align: center;
    }
  }
`
export const MainBochnia = styled.div`
  background: url(${bochniaBackground}) top center no-repeat fixed;
  height: 100vh;
  width: 100%;
  background-size: cover;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 8.5rem;
  width: 100%;
  gap: 13px;
  position: relative;
  aspect-ratio: 16/9;

  @media (max-width: 1700px) {
    //background-size: auto 100%;
  }

  @media (max-width: 1149px) {
    width: 100%;
    height: 100vh;
    background-position-x: -50px;

    background-size: cover;
  }

  @media (max-width: 799px) {
    width: 100%;
    height: 100vh;
    background-position-x: -160px;

    background-size: cover;
  }

  h1 {
    font-size: 2rem;
    font-weight: 600;
    line-height: 3rem;
    letter-spacing: 0.3em;

    ${props =>
      props.goldHeader === true
        ? css`
            background: linear-gradient(
              97.55deg,
              #ce9638 0%,
              #eae69c 36%,
              #b6872d 90.31%,
              #bb913c 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          `
        : css`
            color: #fdfdfd;
          `}

    z-index: 4;
    margin-top: 25px;

    @media (max-width: 500px) {
      width: 80%;
      text-align: center;
    }
  }
`

export const LogoBox = styled.div`
  width: 100%;
  height: 189px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid #fdfdfd;
  background: rgba(3, 3, 3, 0.01);
  z-index: 4;

  @media (max-width: 500px) {
    width: 88.88%;
  }

  img {
    width: 320.5px;
    height: 98px;

    @media (max-width: 439px) {
      width: 240px;
      height: 73.5px;
    }
  }
`
